import { Grid, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useMainDashboardLayoutContext } from "../../../context/SuperAdmin/DashboardContexts/MainDashboardLayout";
import { Spinner } from "../../Loading/Spinner";
import { useAuthContext } from "../../../hooks/Auth";
import PickOrg from "./PickOrg";

const DashboardLayout = () => {
  const { isLoadingOrgs } = useMainDashboardLayoutContext();
  const { canAccess } = useAuthContext();
  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: 4,
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Dashboards</b> | Gestión de créditos
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Seleccionar organizacion */}
          {canAccess("view:dashboard") && (
            <Grid item>
              <PickOrg />
            </Grid>
          )}
        </>
      )}
      <Outlet />
    </Grid>
  );
};

export default DashboardLayout;
